import React from 'react';
import Table from "../../../../componets/Table";
import { useAppSelector } from "../../../../store/hooks";
import { ColumnsType } from "antd/es/table";
import { DeviceInterface } from "../../../../store/mine_craft/devicesSlice";
import { formattedDate } from "../../../../helpers/DateHelpers";

interface ListTableInterface {
  className?: string;
}

const _ListTable = ({ className }: ListTableInterface) => {
  const ids             = useAppSelector(state => state.mineCraft.devices.ids);
  const devices   = useAppSelector(state => state.mineCraft.devices.entities);
  const data            = ids ? ids.map(id => devices[id]) : [];

  const columns: ColumnsType<DeviceInterface> = [
    {
      key: 'id',
      title: 'Id',
      render: (_, { id }) => id,
      width: 60
    },

    {
      key: 'vendor',
      title: 'VendorID',
      render: (_, { vendor }) => vendor,
      width: 125
    },

    {
      key: 'created_at',
      title: 'Created at',
      render: (_, { created_at }) => {
        return <small>{formattedDate(created_at).dateTime}</small>;
      },
      width: 125
    },

    {
      key: 'updated_at',
      title: 'Updated at',
      render: (_, { updated_at }) => {
        return <small>{formattedDate(updated_at).dateTime}</small>;
      },
      width: 125
    },
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />
    </div>
  )
}

export default _ListTable;
